import React from 'react'
import waiting from '../assets/images/icons8-animal-96.png'
import Navbar from './Navbar'
const Blogs = () => {
  return (
    <>
    <Navbar/>
    <div className="bg-brand_nero flex flex-col justify-center items-center h-[760px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar h-[400px] px-24 flex flex-col justify-center items-center w-[600px]">
        <img src={waiting} alt="" />
          <h1 className="text-2xl my-3 text-[#F37E98]">Something new is coming up!</h1>
          <h1>Keep in touch for updates...</h1>
          
          
          
        </div>
      </div>
    </>
    
  )
}

export default Blogs